<template>
    <div>
        <span>{{ message }}</span>
    </div>
</template>

<script>
export default {
    name: "VoiceAgentBatchCallCreated",
    props: {
        activity: {
            type: Object,
            required: true
        }
    },
    computed: {
        message() {
            return this.$t('notification.voiceAgentBatchCallCreated', {
                actor: this.$_.get(this.activity, 'actorUser.name'),
                batchCallName: this.$_.get(this.activity, 'payload.batchCallName'),
                taskCount: this.$_.get(this.activity, 'payload.taskCount', 0)
            });
        }
    }
};
</script>

